module.exports = __webpack_public_path__ + "assets/img/carousel_shop.01b7bc8d.jpg";